export default __webpack_public_path__ + "static/media/lorcana_epic.1b4af966.svg";